module.exports = __webpack_public_path__ + "img/cju_gallery9.c89abb21.jpg";